import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import PublicRecordingView from "./components/sharing/PublicRecordingView";

import './tailwind.css';

// Public-share route: /r/:shareId renders an unauthenticated viewer for
// a single shared recording. Anything else falls through to the regular
// authenticated app shell. We do this at the index level (before <App />
// renders) so visitors don't pay for the auth bootstrap, the practice
// data fetches, etc. — they get a page that's just the player.
const sharePathMatch = window.location.pathname.match(/^\/r\/([^/?#]+)/);
const shareId = sharePathMatch ? decodeURIComponent(sharePathMatch[1]) : null;

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    {shareId ? <PublicRecordingView shareId={shareId} /> : <App />}
  </StrictMode>
);
